import { IResponseState } from "../components/Modals/ResponseModal/module/constants";
import { IGetTabResponse } from "../pages/CertificationReference/CertificationReferenceStepTwo/module/constants";

export enum TaskActionType {
  PERMISSION_ADD = 1,
  PERMISSION_REMOVE = 2,
  AGGREGATED = 3,
  ACCOUNT_DISABLE = 6,
  ACCOUNT_ENABLE = 7,
  ACCOUNT_CREATE = 8,
  ACCOUNT_REMOVE = 9,
  ACCOUNT_MODIFY = 10,
  ACCOUNT_PWDCHANGE = 11,
}

export const REQUEST_ACTION_LIST = [
  {
    label: "AGGREGATED",
    value: 3,
  },
  {
    label: "PERMISSION_ADD",
    value: 1,
  },
  {
    label: "PERMISSION_REMOVE",
    value: 2,
  },
  {
    label: "ACCOUNT_DISABLE",
    value: 6,
  },
  {
    label: "ACCOUNT_ENABLE",
    value: 7,
  },
  {
    label: "ACCOUNT_CREATE",
    value: 8,
  },
  {
    label: "ACCOUNT_REMOVE",
    value: 9,
  },
  {
    label: "ACCOUNT_MODIFY",
    value: 10,
  },
  {
    label: "ACCOUNT_PWDCHANGE",
    value: 11,
  },
];

export interface ITaskItem {
  id: number | string;
  internal_id: string;
  type?: string;
  status?: string;
  application: string;
  entitlement: string;
  beneficiary: string;
  createdOn?: Date | number | string;
  appointee?: string;
  applicant: string;
  parentId: string;
  beneficiary_id: string;
  beneficiary_code?: string;
  action: string;
  beneficiary_email?: string;
  comment?: string;
  enrichment?: string;
  enrichmentCode?: string;
  identity_system_id?: string;
}

export interface IinChargeOfItem {
  inChargeOf: IInChargeOfSubitem;
}
export interface IInChargeOfSubitem {
  id: string;
  code: string;
  name: string;
  surname: string;
  organizational_unit_code: string;
  organizational_unit: string;
  resp_code: string;
  resp_full_name: string;
  type: string;
  company: string;
  sections: string[];
  roles: {
    basicRoles: any[];
    delegatedRoles: any[];
  };
}

export interface ITaskItemRow extends ITaskItem {
  applicant_id: string;
  applicantId: string;
  application_id: string;
  beneficiary_id: string;
  delegant: any;
  delegant_id: any;
  entitlement_id: string;
  identity_status: any;
  identity_trace: any;
  ticket_id: any;
  ticket_system: any;
  entitlementStartDate: Date | string | number;
  entitlementEndDate: Date | string | number;
  applicantFullname: string;
  inChargeOf: string;
  inChargeOfCode: string;
  reqComment: string;
  beneficiaryId: string;
  beneficiaryEmail: string;
}

export interface ITaskPaginatedResponse extends IGetTabResponse {
  tasks: ITaskItemRow[];
}

export interface ITaskOperationValue {
  newValue: string;
  oldValue: string;
}

export interface ITaskFixedAttributes {
  "@fixed_accountType_name": ITaskOperationValue;
  "@fixed_code": ITaskOperationValue;
  "@fixed_display_name": ITaskOperationValue;
  "@fixed_dn": ITaskOperationValue;
  "@fixed_email": ITaskOperationValue;
  "@fixed_expire": ITaskOperationValue;
  "@fixed_isDefault": ITaskOperationValue;
  "@fixed_last_access_date": ITaskOperationValue;
  "@fixed_last_pwd_change": ITaskOperationValue;
  "@fixed_last_wrong_login": ITaskOperationValue;
  "@fixed_name": ITaskOperationValue;
  "@fixed_number_login_error": ITaskOperationValue;
  "@fixed_surname": ITaskOperationValue;
}

export interface ITaskOperationDetail {
  fixedAttributes: ITaskFixedAttributes;
  remoteAttributes: any;
}

export interface ITaskOperationSnapshot {
  action: string | number | any;
  application: string;
  account_id: string;
  cod_operation: string;
  details: ITaskOperationDetail;
  erc_status: any;
  provisioning: string;
  state: any;
  user_id: string;
  task_id: string;
  description: string;
  bao_code: string;
  bao_fullname: string;
  operationExecuted?: boolean;
  enrichment?: IinChargeOfItem;
}
export interface ITaskDetailKey {
  application: string;
  codeOperation: string;
  userId: string;
  action?: string;
  createdOn?: number;
  taskBeneficiaryInfo?: string;
}

export interface ITaskDetail {
  taskKey: ITaskDetailKey;
  taskDetails: ITaskOperationSnapshot[];
}
export interface ITaskDetailRequestBody {
  parentId: string;
  userId: string;
  application: string;
}

export interface ITaskRequestDetail {
  selectedTask: ITaskItem;
  taskDetail: ITaskDetail;
  mainCallState: IResponseState;
  takeChargeCallState: IResponseState;
  taskLoader: boolean;
  userInfo: any;
  fetchTaskDetail: (body: ITaskDetailRequestBody) => {};
  execute: (body: ITaskAcceptRequestBody[]) => {};
  reject: (body: string[]) => {};
  executeWithComment: (req: {
    body?: ITaskAcceptRequestBody[];
    comment: string;
  }) => {};
  rejectWithComment: (req: { body?: string[]; comment: string }) => {};
  goBack: () => {};
  resetTaskDetail: () => {};
  takeChargeRequest: (payload: any[]) => {};
  cancelTakeChargeRequest: (payload: any[]) => {};
  setSelectedAggregateTask: (payload: any[]) => {};
}

export enum TaskOperationType {
  EXECUTE = "EXECUTE",
  UNEXECUTE = "UNEXECUTE",
}

export interface ITargetAttribute {
  value: string;
  accountCfgAttrKey_name: string;
}

export interface ITaskAccountBody {
  id?: string;
  isDefault?: number;
  accountType_name?: string | number;
  code?: string | number;
  display_name?: string | number;
  dn?: string | number;
  email?: string | number;
  expire?: string | number;
  last_access_date?: string | number;
  last_pwd_change?: string | number;
  last_wrong_login?: string | number;
  name?: string | number;
  number_login_error?: string | number;
  surname?: string | number;
  targetAttributes?: ITargetAttribute[];
}

export interface ITaskAcceptRequestBody {
  taskId: string;
  account?: ITaskAccountBody;
}
